"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const InputText_1 = __importDefault(require("@Components/Fields/InputText"));
const fields_validators_1 = require("@App/helpers/work-entities/fields-validators");
const Button_1 = require("@Components/Buttons/Button");
const check_publisher_is_valid_1 = require("@App/helpers/check-publisher-is-valid");
const validate_1 = require("@App/helpers/validate");
const EditSimplePublisher = (props) => {
    const { publisher, title, subtitle, validatePublisherName, returnPublisher, editButtonText, publisherNameText } = props;
    const [publisherName, setPublisherName] = (0, react_1.useState)(publisher.publisherName);
    const [publisherNameError, setPublisherNameError] = (0, react_1.useState)();
    const [ipiNumber, setIpiNumber] = (0, react_1.useState)(publisher.ipiNumber);
    const [ipiNumberError, setIpiNumberError] = (0, react_1.useState)();
    const [isDisabled, setIsDisabled] = (0, react_1.useState)(!(0, check_publisher_is_valid_1.isPublisherNameAndIpiValid)(publisher.publisherName, publisher.ipiNumber));
    const publisherShare = publisher.publisherShare;
    const getValue = (value, id) => {
        value = value.trim();
        switch (id) {
            case 'publisherName':
                setPublisherNameError(validatePublisherName(value));
                setPublisherName(value);
                setIsDisabled(!(0, check_publisher_is_valid_1.isPublisherNameAndIpiValid)(value, ipiNumber));
                break;
            case 'ipiNumber':
                setIpiNumberError((0, validate_1.checkIPIFormatWithErrors)(value));
                setIpiNumber(value.length ? value : null);
                setIsDisabled(!(0, check_publisher_is_valid_1.isPublisherNameAndIpiValid)(publisherName, value.length ? value : null));
                break;
            default:
                break;
        }
    };
    const editPublisher = () => {
        returnPublisher({
            publisherName,
            ipiNumber: ipiNumber ? ipiNumber : null,
            publisherShare,
        });
    };
    return (react_1.default.createElement("div", { className: "original-publisher-sub-form-component" },
        react_1.default.createElement("h2", null, title),
        react_1.default.createElement("h5", { className: 'medium subtitle' }, subtitle),
        react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'publisherName', label: publisherNameText, assistiveText: 'Required', errorMessage: publisherNameError, value: publisherName, onChange: getValue, isEscapeNewlines: true }),
        react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'ipiNumber', label: 'IPI Number', errorMessage: ipiNumberError, assistiveText: 'Required', value: ipiNumber, onChange: getValue }),
        publisherShare !== 0 && (react_1.default.createElement("div", { className: `small ${(0, fields_validators_1.publisherShareInvalidCheck)(publisherShare) ? 'red-text bold' : ''}` },
            react_1.default.createElement("span", { className: "grey-text-2" }, "Publisher share"),
            react_1.default.createElement("h1", { className: 'percent' }, publisherShare))),
        react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: editPublisher, disabled: isDisabled }, editButtonText),
        react_1.default.createElement("div", { className: "help-area" },
            react_1.default.createElement("h5", { className: "title" }, "How do I add shares?"),
            react_1.default.createElement("p", { className: "info" }, "To edit the publisher or administrator percentage amount, return to the Add Publishers page and click the Next button to edit the percentage on the next page."))));
};
exports.default = (0, mobx_react_1.observer)(EditSimplePublisher);
